import React, { FC } from 'react';
import { RoomExtra, RoomExtraOption } from 'shared-types/Room';
import { Extra } from '@common/components/Extras';
import { PerStay } from './PerStay';
import { Options } from './Options';
import { ExtrasCategoryTitle } from './ExtrasCategoryTitle';
import { JourneyParams } from 'shared-types';
import { MultiRoomPerStay } from './PerStay/MultiRoomPerStay';
import { MULTI_ROOM_RATE_CONFIGURATION_FORM_NAME } from '@features/RoomRateConfigurationWizard/shared';

type ExtrasProps = {
  extras?: RoomExtra[] | null;
  selectedExtras?: { isSelected?: boolean; option: RoomExtraOption }[];
  journeyParams: JourneyParams;
  guests: { room: number; title: string; firstName: string; lastName: string; gender: string }[];
  isMultiRoom: boolean;
};

export const Extras: FC<ExtrasProps> = ({
  extras,
  selectedExtras = [],
  journeyParams,
  guests = [],
  isMultiRoom,
}) => {
  return (
    <>
      {extras &&
        extras.map((extra, index) => {
          const isSelected = selectedExtras[index] && selectedExtras[index].isSelected;
          const extraOption = selectedExtras[index] && selectedExtras[index].option;
          return (
            <>
              <ExtrasCategoryTitle extras={extras} index={index} />
              <Extra
                featured
                showPrice
                controls={(() => {
                  switch (extra.type) {
                    case 'per_stay': {
                      return isMultiRoom ? (
                        <MultiRoomPerStay
                          {...extra}
                          id={index}
                          journeyParams={journeyParams}
                          formName={MULTI_ROOM_RATE_CONFIGURATION_FORM_NAME}
                          guests={guests}
                        />
                      ) : (
                        <PerStay {...extra} id={index} />
                      );
                    }
                    default: {
                      return (
                        <Options
                          {...extra}
                          selectedOption={extraOption}
                          id={index}
                          isSelected={isSelected}
                        />
                      );
                    }
                  }
                })()}
                isSelected={isSelected}
                {...(extra as any)}
              />
            </>
          );
        })}
    </>
  );
};
